/* src/views/LoginView.js */
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { LogIn } from 'lucide-vue-next'
import { authServiceAdmin } from '../services/auth'
import Swal from 'sweetalert2'

export default {
  name: 'LoginView',

  components: {
    LogIn
  },

  setup() {

    const router = useRouter()
    const username = ref('')
    const password = ref('')

    const handleLogin = async () => {

      if (username.value && password.value) {

        try {

          await authServiceAdmin.login(username.value, password.value)
          router.push('/services')
        } 
        catch (error) {

          Swal.fire({
            title: 'Errore',
            text: "Login fallito: verifica username e password.",
            icon: 'error',
            confirmButtonText: 'Chiudi'
          })
        }
      } 
      else {

        Swal.fire({
          title: 'Errore',
          text: "Inserisci username e password",
          icon: 'error',
          confirmButtonText: 'Chiudi'
        })
      }
    }

    return {
      username,
      password,
      handleLogin
    }
  }
}